import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { PaginationController } from 'app/components/common';
import { CourseListItem } from '../courseListItem/CourseListItem';
import { LoadingPopup } from '../loadingPopup/LoadingPopup';

import './styles.less';

export const CourseList = ( props ) => {
    // Extract properties from the incoming props.
    const { courseList, coursesPerPage, loading, token  } = props;

    const [ activePage, setActivePage ] = useState( 0 );

    const handlePageChange = useCallback( ( pageIndex, _pageCount ) => {
        setActivePage( pageIndex );
    }, [ setActivePage ] );

    const allCourseItems = useMemo( () => {
        let items = [];
        if ( courseList.length > 0 ) {
            items = courseList.map( ( course, index ) => {
                return ( <CourseListItem key={ index } course={ course } token={ token } /> );
            } );
        }
        return items;
    }, [ courseList, token ] );

    // The course items to display on the currently active page.
    const coursesForPage = useMemo( () => {
        const sliceStart = ( activePage * coursesPerPage );
        return allCourseItems.slice( sliceStart, sliceStart + coursesPerPage );
    }, [ allCourseItems, activePage, coursesPerPage ] );

    const loadingCourseVisuals = useMemo( () => {
        let elems = [];
        for ( let i = 0; i < coursesPerPage; i++ ) {
            elems.push( <CourseListItem key={ i } loading /> );
        }
        return elems;
    }, [ coursesPerPage ] );

    return (
        <div className="course-list">
            <LoadingPopup visible={ loading } />

            <div className="course-list-content">
                { !loading ? ( courseList && courseList.length > 0 )
                    /* Valid   */ ? coursesForPage
                    /* Empty   */ : <div>No courses available!</div>
                    /* Loading */ : loadingCourseVisuals
                }
            </div>
            <div className="course-list-footer">
                <PaginationController
                    pageSize={ coursesPerPage }
                    itemCount={ !loading ? allCourseItems.length : 0 }
                    onChange={ handlePageChange }
                />
            </div>
        </div>
    );
};

CourseList.defaultProps = {
    loading: false,
    courseList: [],
    coursesPerPage: 8,
};

CourseList.propTypes = {
    loading: PropTypes.bool,
    courseList: PropTypes.array,
    coursesPerPage: PropTypes.number,
};
